module.exports = __webpack_public_path__ + "img/blank-user-profile.5a021ab9.png";